<template>
    <div>
        <div id="app" class="kgk-embed" v-if="isEmbedded">
            <embedded />
        </div>
        <div id="app" class="kgk-app" v-else>
            <nav class="main-navbar">
                <div class="nav-topbar">
                    <router-link to="/" class="brand">
                        <img src="@/assets/LogoKMgKweiss-1024x256.png" alt="Kilometer gegen Krebs" class="brand-logo">
                    </router-link>

                    <div class="nav-links-wrapper nav-links-wrapper--top">
                        <template v-if="$global.session.token && !$global.session.expired || 1">
                            <router-link v-for="link in navigationLinks" :key="link.slug" :to="link.slug" class="nav-link">
                                <i :class="['icon', navIcon(link.icon)]"></i>
                                <span class="link-text">{{ link.name }}</span>
                            </router-link>
                        </template>
                        <template v-else>
                            <router-link to="/login" class="nav-link">
                                <i class="icon fas fa-sign-in-alt"></i>
                                <span class="link-text">Anmelden</span>
                            </router-link>
                        </template>
                    </div>

                    <div class="nav-actions">
                        <a href="https://www.krebsgesellschaftnrw.de/jetzt-spenden" target="_blank" rel="noopener" class="nav-action nav-action--donate">
                            <i class="fas fa-hand-holding-heart"></i>
                            <span>Spenden</span>
                        </a>
                        <a class="nav-action nav-action--help" @click="showHowToSettingsSettings()">
                            <i class="fas fa-question-circle"></i>
                            <span>Hilfe</span>
                        </a>
                    </div>
                </div>

                <div class="nav-links-wrapper nav-links-wrapper--bottom">
                    <template v-if="$global.session.token && !$global.session.expired || 1">
                        <router-link v-for="link in navigationLinks" :key="link.slug" :to="link.slug" class="nav-link">
                            <i :class="['icon', navIcon(link.icon)]"></i>
                            <span class="link-text">{{ link.name }}</span>
                        </router-link>
                    </template>
                    <template v-else>
                        <router-link to="/login" class="nav-link">
                            <i class="icon fas fa-sign-in-alt"></i>
                            <span class="link-text">Anmelden</span>
                        </router-link>
                    </template>
                </div>
            </nav>
            <!--<notifications :notifications="$global.notifications" />-->
            <router-view />
            <notifications position="top center" classes="vue-notification kgk-notification" :duration="4000" :width="500">
            <!--<template slot="body" slot-scope="props">
                <div>
                <a class="title">
                    {{props.item.title}}
                </a>
                <a class="close" @click="props.close">
                    <i class="fa fa-fw fa-close"></i>
                </a>
                <div v-html="props.item.text">
                </div>
                </div>
            </template>-->
            </notifications>
            <v-dialog />
            <!--<div>
            <br><br>
            <hr>
            Session Token: {{ $global.session.token }}<br>
            Session expired: {{ $global.session.expired }}
            </div>-->


            <modal name="verify-age-settings" height="auto" class="v--modal-box v--modal vue-dialog">
                <div class="dialog-content">
                    <div class="dialog-c-title">Bitte bestätige, dass du mindestens 16 Jahre alt bist </div>
                    <p>Aufgrund einiger Änderungen müssen wir sicherstellen, dass du 16 Jahre oder älter bist. Bitte trage dies in deinem Profil ein.</p>
                </div>

                <div class="vue-dialog-buttons">
                    <router-link :to="{ path: '/profile', query: { jumpto: 'vaj'}}">
                        <button @click="hideVerifyAgeSettings()" class="vue-dialog-button">Zu den Einstellungen</button>
                    </router-link>
                    <!--button @click="hideVerifyAgeSettings()" class="vue-dialog-button">Schließen</button-->
                </div>
            </modal>

            <modal name="height-settings" height="auto" class="v--modal-box v--modal vue-dialog">
                <div class="dialog-content">
                    <div class="dialog-c-title">Bitte trage deine Körpergröße/Schrittlänge ein </div>
                    <p>Bitte trage deine Körpergröße oder deine Schrittlänge in deinem Profil ein. Hieraus errechnen wir die Kilometer, die du gelaufen bist.</p>
                </div>

                <div class="vue-dialog-buttons">
                    <router-link :to="{ path: '/profile', query: { jumpto: 'vaj'}}">
                        <button @click="hideHeightSettings()" class="vue-dialog-button">Zu den Einstellungen</button>
                    </router-link>
                    <!--button @click="hideVerifyAgeSettings()" class="vue-dialog-button">Schließen</button-->
                </div>
            </modal>

            <modal name="how-to-settings" height="auto" class="v--modal-box v--modal vue-dialog">
                <!-- Only show content if howToContent was found -->
                <div class="dialog-content" v-if="howToContent">
                    
                    <!-- Title: Use v-html to render the <strong> tags in text_head -->
                    <div class="dialog-c-title" v-html="howToContent.head"></div>
                    
                    <!-- Body: Use v-html to render the <br> and <strong> tags in text_block -->
                    <div class="dialog-body-text" v-html="howToContent.body"></div>
                    
                </div>

                <!-- Fallback if the identifier 2 is missing -->
                <div class="dialog-content" v-else>
                    <p>Informationen werden geladen...</p>
                </div>

                <div class="vue-dialog-buttons">
                    <button @click="hideHowToSettingsSettings()" class="vue-dialog-button">
                        Okay
                    </button>
                </div>
            </modal>

            <div class="spacer-small"></div>
            <div class="footer" v-if="enableStravaIntegration">
                <img style="width: 250px;margin-right:0" :src="require('@/assets/strava/compatiblewith/cptblWith_strava_light/api_logo_cptblWith_strava_horiz_light.png')" />
            </div>

        </div>
    </div>
</template>

<script>
import user from './api/user';
import sessionHandling from './session-handling';
import Embedded from './views/Embedded.vue';
import donateModal from './helpers/donate-modal';
import popupMessageModal from './helpers/popup-message-modal';

export default {
  components: { Embedded },
    data() {
        return {
            enableStravaIntegration: window.kgkConfig.enableStravaIntegration,
            serverReady: window.kgkServerLoaded,
            user: {
                session_valid:true,
                run_type:0,
            },
            refreshTrigger:0,
            redirectAfterLogin: false,
            redirectAfterLoginTo: '',
            isEmbedded:this.$route.meta.embedded,
            userLoaded:false,
            rawNavLinks: window.kgkMenu,
            modalText: window.kgkTexts,
        }
    },
    computed: {
        userIsLoggedIn(){
            return this.user && !!this.user.identifier;
        },
        howToContent() {
            const target = this.modalText.find(item => item.slug === 'how-to' || item.identifier === 2);

            return target ? {
                head: target.text_head,
                body: target.text_block
            } : 
            {
                head: 'Informationen werden geladen...',
                body: '...'
            };
        },
        navigationLinks() {
            // 1. Start with the full list from your JSON
            let links = [...this.rawNavLinks];

            // 2. Implement your conditional logic here
            // The backend's getMenu should only include /stepsChallenge when this
            // user's company challenge is active; this just guards against it
            // lingering in the menu if that ever falls out of sync.
            // "How-to" is covered by the Hilfe button in the top bar, so it isn't
            // duplicated as its own tab in the main navigation.
            links = links.filter(link => link.slug !== '/how-to');

            // Example: If you want to hide "Spenden" for certain users
            // links = links.filter(link => link.name !== 'Spenden');

            return links;
        }
    },
    methods:{
        navIcon(icon){
            const key = String(icon || '').toLowerCase().replace(/[^a-z0-9]/g, '');
            const icons = {
                home: 'fas fa-home',
                login: 'fas fa-sign-in-alt',
                logout: 'fas fa-sign-out-alt',
                register: 'fas fa-user-plus',
                registrierung: 'fas fa-user-plus',
                questionmark: 'fas fa-question-circle',
                howto: 'fas fa-question-circle',
                profile: 'fas fa-user',
                profil: 'fas fa-user',
                runs: 'fas fa-shoe-prints',
                laeufe: 'fas fa-shoe-prints',
                team: 'fas fa-users',
                wettbewerb: 'fas fa-medal',
                company: 'fas fa-building',
                ranking: 'fas fa-trophy',
                rangliste: 'fas fa-trophy',
            };
            return icons[key] || 'fas fa-circle';
        },
        showHeightSettings(){
            this.$modal.show('height-settings');
        },
        hideHeightSettings(){
            this.$modal.hide('height-settings');
        },
        showVerifyAgeSettings(){
            this.$modal.show('verify-age-settings');
        },
        hideVerifyAgeSettings(){
            this.$modal.hide('verify-age-settings');
        },
        showHowToSettingsSettings(){
            this.$modal.show('how-to-settings');
        },
        hideHowToSettingsSettings(){
            this.$modal.hide('how-to-settings');
        },
        loadUserDetails() {
            if(this.user.session_valid){
                this.loading = true;
                user.getDetails(
                    this,
                    data => {
                        this.user = data.user;
                        this.userLoaded = true;

                        if(this.user.verify_age != true){
                            this.showVerifyAgeSettings();
                        }

                        donateModal.openDonateModalIfNeeded(this.$modal, this.user);
                        popupMessageModal.showPopupMessagesIfNeeded(this.$modal);
                        this.refreshNavigationMenu();
                    },
                    () => this.loading = false,
                );
            }
        },
        checkIfUserIsLoggedIn() {
            if(sessionHandling.isLoggedIn()){
                console.log('loaded...')
            }
        },
        refreshNavigationMenu() {
            // The menu is only fetched once at app boot, so conditional entries
            // (e.g. an active challenge) wouldn't otherwise appear/disappear
            // until a full page reload. Re-fetching keeps it in sync.
            sessionHandling.refreshMenu()
                .then(menu => { this.rawNavLinks = menu; })
                .catch(() => {});
        },
        // Called by LogoutForm.vue after a successful logout -- unlike
        // login, there's no follow-up user to fetch (the token's already
        // cleared), so this resets back to the same guest-shaped default as
        // data()'s initial `user`, then re-fetches the menu, which now
        // resolves to the guest menu since the auth header is gone. Without
        // this, the top/bottom nav kept showing the authenticated menu
        // (Team/Profil/Wettbewerb/Logout) until a full page reload.
        resetUserOnLogout() {
            this.user = { session_valid: true, run_type: 0 };
            this.userLoaded = false;
            this.refreshNavigationMenu();
        },
    },
    watch: {
        userLoaded(newVal, oldVal){
            //if user loading is successfull, we can trigger something here :)
            // if(newVal){
                
            // }
        },
        '$route.path'(newPath){
            if(newPath === '/how-to') {
                this.$modal.show('how-to-settings');
            }
        },
    },
    mounted(){
        //this.checkIfUserIsLoggedIn();
        this.loadUserDetails();
        this.checkIfUserIsLoggedIn();
        if (this.$route.path === '/how-to') {
            this.$modal.show('how-to-settings');
        }

        // Keep conditional nav entries (e.g. an active challenge) in sync for
        // long-lived sessions without requiring a full page reload.
        this.menuRefreshInterval = setInterval(this.refreshNavigationMenu, 5 * 60 * 1000);
    },
    beforeDestroy(){
        clearInterval(this.menuRefreshInterval);
    },
}
//import admin from './api/admin';

// admin.getConfigFromServer(
//     this,
//     data => window.kgkConfig = JSON.parse(data)
// );
// admin.getRoutesFromServer(
//     this,
//     data => window.kgkRoutes = JSON.parse(data)
// );

</script>

<style lang="scss">
/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  //font-family: Arial, Sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}*/

#app {
  text-align: center;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  /*position: fixed;
  top: 0;
  left: 0;*/

  padding: 30px;

  font-size: 18px;

  a {
    font-weight: bold;
    color: inherit;
    //color: #2c3e50;

    &.router-link-exact-active {
      color: #82C800;
      //color: #42b983;
    }
  }

  margin-bottom: 50px;
}
.kgk-left {
    text-align: left;
}
.kgk-center {
    text-align: center;
}
</style>
